<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-plus"></i> Creación de Orden de Devolución
    </div>
    <div class="card-body">
      <accordion [isAnimated]="true">
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-users'></i> Factura o Recibo a ingresar
          </span>
          <form #invoiceForm="ngForm" (ngSubmit)="invoiceForm.valid && searchInvoice()">

            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label"><b>Número de Factura</b></label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 input-group">
                <input type="text" id="invoiceModel" name="invoiceModel" class="form-control" #invoiceModel="ngModel"
                  [(ngModel)]="invoiceCode" mask="000-000-00-00000000" [showMaskTyped]="true"
                  [dropSpecialCharacters]="false" [disabled]="this.isLoaded">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="submit"><i class="fa fa-search"></i></button>
                </div>
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="clear()"><i
                      class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
          </form>
          <form #receiptForm="ngForm" (ngSubmit)="receiptForm.valid && searchReceipt()">

            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label"><b>Recibo</b></label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 input-group">
                <input type="text" id="receiptModel" name="receiptModel" class="form-control" #receiptModel="ngModel"
                  [(ngModel)]="receiptCode" [disabled]="this.isLoaded">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="submit"><i class="fa fa-search"></i></button>
                </div>
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="clear()"><i
                      class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
          </form>
        </accordion-group>
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-users'></i> Información General
          </span>
          <div class="form-group row">
            <label class="col-md-3 col-form-label"><b>Cliente</b></label>
            <div class="col-md-9">
              <input type="text" class="form-control" disabled [(ngModel)]="customerInformation">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Vendedor</b></label>
            <div class="col-md-9">
              <input type="text" class="form-control" [(ngModel)]="order.vendorName" disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Sucursal</b></label>
            <div class="col-md-9">
              <input type="text" class="form-control" [(ngModel)]="branchInformation" disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Documento Fiscal</b></label>
            <div class="col-md-9">
              <input type="text" class="form-control" [(ngModel)]="order.customerFiscalId" disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Fecha de la Orden Original</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="order.timeStamp"
                disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Motivo de Devolución</b></label>
            <div class="col-md-9">
              <ng-select [items]="cancellationReasons" bindLabel="description" [(ngModel)]="cancellationReasonSelected"
                #cancellationReason (change)="cancellationReason.blur()" required></ng-select>
            </div>
          </div>

        </accordion-group>
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-cart-shopping'></i> Productos
          </span>
          <div class="row">
            <div class="col-12">
              <pos-table tableFormId="productsCartTable" [data]="productsCart" [headers]="getProductCartHeaders()"
                [filters]="[]" [itemsPerPage]="10" [pagination]="false" [disableHighlight]="true"
                (dataSave)="saveProductCart($event)">
              </pos-table>
            </div>
          </div>
        </accordion-group>
      </accordion>
    </div>
    <div class="card-footer">
      <div class=" btn-group float-right">
        <button type="button" (click)="create()" [disabled]="!isLoaded" class="btn btn-outline-success float-right"><i
            class="fa fa-plus"></i>&nbsp;Crear</button>
        <button type="button" (click)="observations()" [disabled]="!isLoaded" class="btn btn-sm btn-outline-success"><i
            class="fa fa-pen-to-square"></i>&nbsp;Observaciones</button>
      </div>
    </div>
  </div>

</div>